import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { ResponseEventParams } from '@webapp/survey/src/entities/response-machine';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { MatrixApi } from './common/matrix';

export class MatrixFewAnswersApi extends MatrixApi {
    public change(
        { answersActors, groupsActors, params, responseActor, id: questionId }: QuestionContext,
        { value, groupId, answerId }: ResponseEventParams,
    ): void {
        const { maxLength, minLength } = params;

        const group = groupsActors.find((groupActor) => groupActor.getSnapshot().context.id === groupId);

        // todo разобраться что это и для чего
        if (params.maxLength) {
            const sumOfAnswers = {};
            groupsActors.forEach((groupActor) => {
                Object.entries(groupActor.getSnapshot().context.responses).forEach(([answerId, r]) => {
                    if (!sumOfAnswers[answerId]) {
                        sumOfAnswers[answerId] = 0;
                    }
                    sumOfAnswers[answerId] += r.getSnapshot().context.value ? 1 : 0;
                });
            });
            if (!sumOfAnswers[answerId]) {
                sumOfAnswers[answerId] = 0;
            }
            sumOfAnswers[answerId] += value ? 1 : 0;
            if (sumOfAnswers[answerId] > params.maxLength) {
                responseActor.send({ type: 'SET', value: false });
            }
        }

        if (group.getSnapshot().context.exception) {
            groupsActors.map((groupActor) => {
                if (groupActor.getSnapshot().context.id !== group.getSnapshot().context.id) {
                    groupActor.getSnapshot().context.responses[answerId].send({ type: 'SET', value: false });
                }
            });
        } else {
            groupsActors.map((groupActor) => {
                const group = groupActor.getSnapshot().context;
                if (group.exception) {
                    group.responses[answerId].send({ type: 'SET', value: false });
                }
            });
        }

        answersActors.forEach((answerActor) => {
            const answer = answerActor.getSnapshot().context;
            if (answer.valid) {
                return;
            }
            let isAnswered = 0;
            groupsActors.forEach((groupActor) => {
                if (groupActor.getSnapshot().context.responses[answer.id]?.getSnapshot().context.value) {
                    isAnswered += 1;
                }
            });
            if (!(!isAnswered || (maxLength && maxLength > isAnswered) || (minLength && minLength < isAnswered))) {
                answer.valid = true;
            }
        });

        if (value === CANTRATE_ID) {
            groupsActors.forEach((groupActor) => {
                if (groupActor.getSnapshot().context.id !== group.getSnapshot().context.id) {
                    groupActor.getSnapshot().context.responses[answerId].send({ type: 'SET', value: false });
                }
            });
        } else {
            groupsActors.forEach((groupActor) => {
                if (groupActor.getSnapshot().context.responses[answerId].getSnapshot().context.value === CANTRATE_ID) {
                    groupActor.getSnapshot().context.responses[answerId].send({ type: 'SET', value: false });
                }
            });
        }

        responseActor.send({ type: 'CHANGE', value, questionId });
    }

    public changeExtra(question: QuestionActor, value: PrimitiveValue): void {
        const { responseActor } = question.getSnapshot().context;

        responseActor.send({ type: 'SET', value: !!value });

        super.changeExtra(question, value);
    }
}
